import { render, staticRenderFns } from "./VsmStandaloneUrlCopyButton.vue?vue&type=template&id=4ecca5f1&"
import script from "./VsmStandaloneUrlCopyButton.vue?vue&type=script&lang=js&"
export * from "./VsmStandaloneUrlCopyButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports